import React from 'react';
import {
  Radar,
  RadarChart as RadarChartRecharts,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Legend,
} from 'recharts';

const RadarChart = ({ data }: { data?: any }) => {
  // TODO create it dynamicaly
  const labels = [
    {
      name: '… suits me me',
      dataKey: 'a',
      color: 'brown',
    },
    {
      name: '… is reliable',
      dataKey: 'b',
      color: 'red',
    },
    {
      name: '… understands my needs',
      dataKey: 'c',
      color: 'blue',
    },
    {
      name: '… makes my life easier',
      dataKey: 'd',
      color: 'green',
    },
  ];
  return (
    <ResponsiveContainer width="100%" minHeight="400px">
      <RadarChartRecharts
        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
        data={data}
      >
        <PolarGrid />
        <PolarAngleAxis dataKey="name" />
        <PolarRadiusAxis angle={90} tickCount={6} />
        {labels.map((label: any) => {
          return (
            <Radar
              strokeWidth={2}
              fillOpacity={0.6}
              fill="transparent"
              stroke={label.color}
              key={label.name}
              name={label.name}
              dataKey={label.dataKey}
            />
          );
        })}

        <Legend />
      </RadarChartRecharts>
    </ResponsiveContainer>
  );
};

export default RadarChart;
